function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Cropper from '../../common/Cropper.react';
import AzureBlob from '../../common/AzureBlob.react';
import AddImage from '../../common/assets/add-image/AddImage.button';
import Button from '../../common/Button.react';
var FullImageComponent = function FullImageComponent(_ref) {
  var _assets$, _assets$2, _assets$3;
  var componentID = _ref._id,
    pageID = _ref.pageID,
    _ref$assets = _ref.assets,
    assets = _ref$assets === void 0 ? [] : _ref$assets;
  var dispatch = useDispatch();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState({
      visible: false,
      asset: null,
      assetID: null,
      crop: {},
      reCrop: false,
      filename: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    cropper = _useState4[0],
    setCropper = _useState4[1];
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Full Width Image Component",
    button: {
      label: 'Delete',
      type: 'delete',
      apiID: 'delete-component',
      requireConfirmation: true,
      onClick: function onClick() {
        dispatch({
          type: ppcActions.pageComponent,
          payload: {
            formData: {
              componentID: componentID,
              pageID: pageID,
              apiID: 'delete-component'
            },
            method: 'delete'
          }
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", null, ((_assets$ = assets[0]) === null || _assets$ === void 0 ? void 0 : _assets$.filename) && /*#__PURE__*/React.createElement(AzureBlob, {
    filename: (_assets$2 = assets[0]) === null || _assets$2 === void 0 ? void 0 : _assets$2.filename,
    assetID: (_assets$3 = assets[0]) === null || _assets$3 === void 0 ? void 0 : _assets$3.asset
  })), (assets === null || assets === void 0 ? void 0 : assets.length) < 1 ? /*#__PURE__*/React.createElement(AddImage, {
    blobType: "ppcPageComponentAsset",
    onCrop: function onCrop(data) {
      dispatch({
        type: ppcActions.pageComponent,
        payload: {
          formData: {
            componentID: componentID,
            blobType: 'ppcPageComponentAsset',
            assetID: data.assetID,
            crop: data.crop,
            pageID: pageID,
            apiID: 'add-image-button'
          },
          method: 'post',
          route: 'asset'
        }
      });
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Re-Crop",
    onClick: function onClick() {
      setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        assetID: state.asset,
        visible: true,
        crop: state.crop,
        reCrop: true,
        filename: state.filename
      }));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    icon: "lock-icon@3x.png",
    apiID: "delete-image",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.pageComponent,
        payload: {
          formData: {
            componentID: componentID,
            pageID: pageID,
            assetID: assets[0]._id,
            blobType: 'ppcPageComponentAsset',
            apiID: 'delete-image'
          },
          method: 'delete',
          route: 'asset'
        }
      });
    }
  })), /*#__PURE__*/React.createElement(Cropper, {
    visible: cropper.visible,
    asset: cropper.asset,
    assetID: cropper.assetID,
    crop: cropper.crop,
    type: "ppcPageBanner",
    onClose: function onClose() {
      return setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        visible: false
      }));
    },
    onCrop: function onCrop(_ref2) {
      var crop = _ref2.crop,
        assetID = _ref2.assetID;
      dispatch({
        type: ppcActions.pageComponent,
        payload: {
          formData: {
            componentID: componentID,
            blobType: 'ppcPageComponentAsset',
            crop: {
              x: crop.x,
              y: crop.y,
              w: crop.width,
              h: crop.height
            },
            assetID: assetID,
            pageID: pageID,
            filename: state.filename
          },
          method: 'put',
          route: 'asset'
        }
      });
      setCropper({
        visible: false,
        asset: null,
        assetID: null,
        reCrop: false,
        filename: null
      });
    }
  })));
};
export default FullImageComponent;